import { Dispatch } from 'redux';
import { SortingGeneric, TableColumnWidthInfoGeneric } from '../history-table-settings/types';
import { setColumnOrderAction, setColumnSizeAction, setColumnSortingAction } from './actions';
import { ServiceHistoryDtoKeys } from './types';

export function setSorting(sorting: SortingGeneric<ServiceHistoryDtoKeys>[]) {
	return (dispatch: Dispatch<any>) => {
		dispatch(setColumnSortingAction(sorting));
	};
}

export function setSize(columnWidths: TableColumnWidthInfoGeneric<ServiceHistoryDtoKeys>[]) {
	return (dispatch: Dispatch<any>) => {
		dispatch(setColumnSizeAction(columnWidths));
	};
}

export function setOrder(columnOrder: ServiceHistoryDtoKeys[]) {
	return (dispatch: Dispatch<any>) => {
		dispatch(setColumnOrderAction(columnOrder));
	};
}
